import React from 'react'

import { AvatarGroup as MUIAvatarGroup, SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'
import Icon, { IconProps } from 'components_new/atoms/Icon'
import Text from 'components_new/atoms/Text'
import Tooltip, { TooltipProps } from 'components_new/atoms/Tooltip'

import GenericAvatar from 'components_new/molecules/GenericAvatar'

import { Option } from '../SelectSearch'

interface AvatarGroupProps {
  emptyIcon: IconProps
  items: Option[]
  max?: number
  onClick?: () => void
  sx?: SxProps
  tooltip?: TooltipProps['title']
}

const AvatarGroup = React.forwardRef((props: AvatarGroupProps, ref: any) => {
  const { emptyIcon, items, max = 3, onClick, sx, tooltip } = props

  return (
    <>
      <Tooltip title={tooltip}>
        <Box
          onClick={(e) => {
            if (onClick) {
              e.stopPropagation()
              onClick()
            }
          }}
          onMouseDown={(e) => {
            if (onClick) {
              e.stopPropagation()
            }
          }}
          ref={ref}
          sx={{
            alignItems: 'center',
            borderRadius: 1,
            cursor: 'pointer',
            display: 'flex',
            fontSize: '0.7rem',
            gap: 0.5,
            height: 28,
            py: '2px',
            px: '3px',
            ['&:hover']: {
              bgcolor: 'action.hover'
            },
            ...sx
          }}
        >
          {items.length > 0 ? (
            <MUIAvatarGroup spacing={16}>
              {items.slice(0, max).map((item, i) => (
                <GenericAvatar
                  color={item.color}
                  component="avatar"
                  key={i}
                  size="small"
                  title={item.title}
                  variant={item.avatar ?? 'user'}
                />
              ))}
            </MUIAvatarGroup>
          ) : null}

          {items.length > max ? (
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                bgcolor: 'grey.100',
                borderRadius: 1,
                fontSize: 'inherit',
                height: 20,
                ml: -1,
                pl: 1,
                pr: 0.5
              }}
            >
              +{items.length - max}
            </Box>
          ) : null}

          {items.length === 0 ? (
            <>
              <Icon
                color="disabled"
                {...emptyIcon}
                sx={{ fontSize: '1.5em' }}
              />
              <Text
                color="text.disabled"
                lineHeight={1}
                sx={{
                  fontSize: 'inherit'
                }}
              >
                0
              </Text>
            </>
          ) : null}
        </Box>
      </Tooltip>
    </>
  )
})

AvatarGroup.displayName = 'AvatarGroup'
export default AvatarGroup
